import type { TranslateServerSideModel } from '../models/translate-server-side-model';

export interface TranslateStage {
    /**
     * 前置条件
     */
    isNextStage(model: TranslateServerSideModel): boolean;
    /**
     * 当前阶段
     */
    isCurrentStage(model: TranslateServerSideModel): boolean;
    /**
     * 后置条件
     * @description 用于判断是否为当前 stage 的 prev stage
     */
    isPreviousStage(model: TranslateServerSideModel): boolean;
    /**
     * 离开阶段
     */
    onLeave(): Promise<void>;
    /**
     * 进入阶段
     */
    onEnter(model: TranslateServerSideModel): void | Promise<void>;
}

export const TranslateStage = Symbol('TranslateStage');
